import createClient from "openapi-fetch";
import { env } from "@/env";
import type { paths } from "./schema";

export const apiClient = createClient<paths>({
  baseUrl: env.VITE_BETTER_AUTH_URL,
  credentials: "include",
});
